var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.store.isTimeTravel && !_vm.store.isSimulation)?_c('span',{staticClass:"tag mx-2"},[_vm._v("Time Travel "),_c('a',{staticClass:"tag-addon",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.resetTimeTravel()}}},[_c('b-icon-x')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }